<script>
  import * as R from 'ramda';
  import { onMount } from 'svelte';
  import TextField from '../lib/components/TextField.svelte';
  import { show_message } from '../lib/flash';
  import APIClient from '../state-charts/api-client';
  import { t9n } from '../lib/translate.js';
  import { TS } from '../config/translation-keys.js';
  import InputWithValidation from '../lib/components/InputField.svelte';
  import session from '../lib/session';
  import Validators from '../lib/validators';

  // component options  ------------------------------------------------------ //

  // internal variables ------------------------------------------------------ //

  let validators = {
    email: true,
    email_confirm: true
  }

  let errors = {
    email: null,
    email_confirm: null,
  }

  let desc;
  let header;
  let optional;
  let invite_successfully_sent;

  let invite_email;
  let invite_email_confirm;
  let invite_name = null;
  let invite_comment = null;

  let send_invite_disabled = true;
  let invite_comment_label;

  // translated strings ------------------------------------------------------ //

  let invite_email_label;
  let invite_name_label;
  let invite_btn_label;
  let invite_email_confirm_label;
  let invite_existing_user_to_other_merch;

  // utility functions -------------------------------------------------------- //

  const reset_state = () => {
    invite_email = null;
    invite_email_confirm = null;
    invite_comment = null;
    invite_name = null;
    send_invite_disabled = true;
  };

  const check_filled = () => {
    const TRUE = R.equals(true);
    const checks = [
      !!invite_email && validators.email,
      !!invite_email_confirm && validators.email_confirm,
    ];

    return R.all(TRUE)(checks);
  };

  const handle_invite = async () => {
    let data = {
      email: invite_email,
      comment: invite_comment,
      name: invite_name,
    };

    let result = await APIClient.submit_invite(data);
    if (!!result) {
      if (result.exists === true) {
        invite_existing_user_to_other_merch = true;
        show_message(invite_successfully_sent, 'success');
      }
      show_message(invite_successfully_sent, 'success');
    }
    reset_state();
  };

  const init_invite = () => {
    document.querySelector('.mdc-top-app-bar--fixed-adjust').scrollIntoView({behavior: "smooth"})
    reset_state();
  };

  const validate_email = (email, email_confirm) => {
    let result = Validators.validate_invite_email(email, email_confirm, $session.user.email);
    if (!!result) {
      validators.email = result.valid;
      errors.email = result.error;
    }
  }

  const validate_email_confirm = (email_confirm, email) => {
    let result = Validators.validate_invite_email(email_confirm, email, $session.user.email);
    if (!!result) {
      validators.email_confirm = result.valid;
      errors.email_confirm = result.error;
    }
  }

  // reactive functions ------------------------------------------------------- //
  $: if(!!invite_email && invite_email.length > 0) validate_email(invite_email, invite_email_confirm);
  $: if(!!invite_email_confirm && invite_email_confirm.length > 0) validate_email_confirm(invite_email_confirm, invite_email);

  $: {
    invite_email;
    invite_email_confirm;

    setTimeout(() => {
      send_invite_disabled = !check_filled();
    }, 500);
  }

  $: {
    invite_email_label = t9n(TS.PILOT_POINTS_DONATE_EMAIL_LABEL);
    invite_email_confirm_label = t9n(
      TS.PILOT_POINTS_DONATE_CONFIRM_EMAIL_LABEL
    );
    invite_name_label = t9n(TS.INVITE_FIRST_NAME_OF_INVITEE);
    invite_comment_label = t9n(TS.PILOT_POINTS_DONATE_LEAVE_COMMENT_LABEL);
    invite_btn_label = t9n(TS.LOGIN_FORM_SEND);
    desc = t9n(TS.INVITE_PEOPLE_TOOLTIP);
    optional = t9n(TS.INVITE_OPTIONAL_SUBSTRING);
    header = t9n(TS.INVITE_PEOPLE_TO_SERVICE);
    invite_successfully_sent = t9n(TS.INVITE_SUCCESSFULLY_SENT);
    // error_invite_email_exists = shared(API);
  }

  // initialization ----------------------------------------------------------- //

  onMount(init_invite);
</script>


  <main class="main--global wrapper fade-in">
    <div style="text-align: center;">
      <h1 style="margin-bottom: 25px" class="mdc-typography--headline5">
        {header}
      </h1>
    </div>
    <div style="text-align: center">
      <div class="content">
        <div class="fade-in">

          <div
            class="tooltip-default"
            style="width: 75%; margin: auto; margin-bottom: 10px; margin-top:
            -10px;">
            <div
              id="tooltip_def"
              class="tooltip-text tooltip-top svelte-wb285v"
              style="background-color:var(--mdc-theme-secondary); color:
              rgb(255, 255, 255);">
              {desc}
            </div>
          </div>

          <InputWithValidation
            id="invite_email"
            type='email'
            label={invite_email_label}
            name="invite_email"
            is_required={true}
            bind:value={invite_email}
            valid={validators.email}
            validation_text={errors.email}
            width='410px' />

          <InputWithValidation
            id="invite_email_confirm"
            type='email'
            label={invite_email_confirm_label}
            name="invite_email_confirm"
            is_required={true}
            bind:value={invite_email_confirm}
            valid={validators.email_confirm}
            validation_text={errors.email_confirm}
            width='410px' />

          <InputWithValidation
            id="invite_email_name"
            type="text"
            label="{`${invite_name_label} ${t9n(TS.INVITE_OPTIONAL_SUBSTRING)}`}"
            name="invite_email_name"
            bind:value={invite_name}
            width='410px' />

          <div id="text_field_cont" style="margin-top: 0;">
            <TextField
              id="invite_comment"
              bind:value={invite_comment}
              label="{invite_comment_label}
              {optional}"
              max_chars={200}
              placeholder={invite_comment_label}
              width="100%" />
          </div>

          <p class='required'>* {t9n(TS.REQUIRED_LABEL)}</p>

          <div style="margin-top: 15px;" />

          <!-- invite button -->
          <div class="actionContainer">
            <button
              id="invite_email_submit"
              disabled={!!send_invite_disabled}
              data-cy="invite_email_submit"
              class="mdc-button mdc-button--raised"
              on:click|preventDefault={async () => { await handle_invite() } }>
              {invite_btn_label}
            </button>
          </div>

        </div>
      </div>

      <!--   <ConfirmDialog
        bind:show_confirm_flag={value_field}
        bind:confirmed_flag={value_field}
        confirm_title={"confirm_title"}
        confirm_text={"confirm_invite_text"}
        confirm_no_label={"confirm_no_label"}
        confirm_yes_label={"confirm_yes_label"}
        confirm_yes_action={"process_confirmed"} />
        -->

    </div>
  </main>

<style type="text/scss">
  .required{
    font-size: 10pt;
    text-align: left;
    margin-left: 95px;
    //margin-top: -10px;
    color: #323232;
  }
  .btn-yes,
  btn-yes:hover {
    background-color: var(--worker-background-color);
    color: var(--worker-foreground-color);
  }

  .actionContainer {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
    margin-right: 20px;
  }

  .service-label {
    color: dimgray;
    font-size: 90%;
    text-align: center;
    margin-top: 1px;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    display: block;
    padding-left: 30px;
    padding-right: 30px;
    /*width: 437px;*/
    font-size: 13px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
  }

  .tooltip-default .tooltip-text::after {
    content: ' ';
    position: relative;
    top: 30px;
    /*left: 50%;*/
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #018786 transparent transparent transparent;
  }

  /* Desktop Mode
   *******************************************************/
  @media (min-width: 1025px) {
    .wrapper {
      width: 600px;
      margin: 0 auto;
      height: fit-content;
    }

    #text_field_cont {
      width: 410px;
      margin: auto;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .wrapper {
      width: 600px;
      margin: 0 auto;
      height: fit-content;
    }

    #text_field_cont {
      width: 410px;
      margin: auto;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .wrapper {
      margin: 0 auto;
      margin-left: 50px;
      margin-bottom: 50px;
      height: fit-content;
    }

    .required{
      margin-left: 0;
    }

    #text_field_cont {
      width: 100%;
    }
  }
</style>
